module.exports = "/_next/static/images/why-lunch-b705fee36f2bfc58721a2c938cf85e92.jpg";